import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: null,
  groups: JSON.parse(localStorage.getItem('userGroups')) || [],
  isAuthenticated: !!localStorage.getItem('token'),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserAuth: (state, action) => {
      state.groups = Array.isArray(action.payload.groups) ? action.payload.groups : [action.payload.groups];
      if (state.groups.includes('admin')) {
        state.role = 'admin';
      } else if (state.groups.includes('editor')) {
        state.role = 'editor';
      } else {
        state.role = 'viewer';
      }
      state.isAuthenticated = true;
    },
    clearUserAuth: (state) => {
      state.groups = [];
      state.role = null;
      state.isAuthenticated = false;
    },
    initializeAuth: (state) => {
      const userGroups = JSON.parse(localStorage.getItem('userGroups')) || [];
      state.groups = Array.isArray(userGroups) ? userGroups : [userGroups];
      if (state.groups.includes('admin')) {
        state.role = 'admin';
      } else if (state.groups.includes('editor')) {
        state.role = 'editor';
      } else {
        state.role = 'viewer';
      }
      state.isAuthenticated = !!localStorage.getItem('token');
    },
  },
});

export const { setUserAuth, clearUserAuth, initializeAuth } = authSlice.actions;
export default authSlice.reducer; 